import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { useMasterData } from "../../Common/commonEvents";
import dayjs from "dayjs";

export default function ConfirmAppointmentModal({
    open,
    onClose,
    onConfirm,
    appointment,
}) {
    const [sessionUserData, setSessionUserData] = useState([]);
    const [doctorId, setDoctorId] = useState("");
    const [timeSlot, setTimeSlot] = useState("");

    useEffect(() => {
        const userData = JSON.parse(sessionStorage.getItem("userData"));

        if (userData) {
            setSessionUserData(userData);
        }
    }, []);

    const {
        usersByRole,
        doctorSlots,
        fetchUsersByRole,
        fetchDoctorSlots,
    } = useMasterData();

    useEffect(() => {
        if (!sessionUserData?.OrgId) return;

        fetchUsersByRole(sessionUserData.OrgId, 2); // doctors
    }, [sessionUserData?.OrgId]);

    useEffect(() => {
        if (!sessionUserData?.OrgId || !doctorId) return;

        fetchDoctorSlots(sessionUserData.OrgId, doctorId); // doctor slots
    }, [sessionUserData?.OrgId, doctorId]);

    const handleConfirm = () => {

        onConfirm?.({
            appointment,
            doctorId,
            timeSlot,
        });
    
        setTimeSlot("");
        onClose?.();
    };

    const handleClose = () => {
        setTimeSlot("");
        onClose?.();
    };

    const generateTimeSlots = (
        startTime,
        endTime,
        duration
    ) => {
    
        const slots = [];

        const formatTimeOnly = (time) => {
            const extracted =
                time.split("T")[1].substring(0, 5);
            return dayjs(
                extracted,
                "HH:mm"
            );
        };
        
        let start = formatTimeOnly(startTime);
        let end = formatTimeOnly(endTime);
        
        // HANDLE NEXT DAY CASE
        if (end.isBefore(start)) {
            end = end.add(1, "day");
        }
    
        while (
            start.add(duration, "minute")
                .isBefore(end) ||
        
            start.add(duration, "minute")
                .isSame(end)
        ) {
    
            slots.push({
                label: start.format("hh:mm A"),
    
                value: start.format("HH:mm"),
            });
    
            start = start.add(
                duration,
                "minute"
            );
        }
    
        return slots;
    };

    const appointmentDayId =
    dayjs(
        appointment?.AppointmentDate
    ).day() + 1;

    const matchedDoctorSlots =
    (doctorSlots || []).filter(
        (slot) =>
            slot.DayId === appointmentDayId
    );

    const availableSlots =
    matchedDoctorSlots.flatMap((slot) =>
        generateTimeSlots(
            slot.StartTime,
            slot.EndTime,
            slot.SlotDuration
        )
    );

    return (
        <Modal
            title={null}
            open={open}
            onCancel={handleClose}
            footer={null}
            centered
            width={620}
            className="confirm-appointment-modal"
        >
            <div className="confirm-modal-header">
                <div className="confirm-modal-icon">
                    <i className="bi bi-calendar2-check text-white"></i>
                </div>

                <div>
                    <h3>Confirm Appointment</h3>
                    <p>Assign a doctor and choose an available slot</p>
                </div>
            </div>

            <div className="confirm-modal-body">
                <div className="row g-3">
                    <div className="col-12">
                        <label className="form-label fw-bold text-muted mb-2">
                            Select Doctor
                        </label>

                        <div className="input-icon-wrap">
                            <i className="bi bi-person-badge"></i>
                            <select
                                className="form-select form-select-lg"
                                value={doctorId}
                                onChange={(e) => setDoctorId(e.target.value)}
                            >
                                <option value="">Select Doctor</option>
                                {usersByRole.map((doctor) => (
                                    <option key={doctor.Id} value={doctor.Id}>
                                        {doctor.Name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="col-12">

    <label className="form-label fw-bold text-muted mb-2">
        Select Available Time Slot
    </label>

    <div className="input-icon-wrap">
        <i className="bi bi-clock-history"></i>

        <select
            className="form-select form-select-lg"
            value={timeSlot}
            onChange={(e) =>
                setTimeSlot(e.target.value)
            }
        >

            <option value="">
                Select Time Slot
            </option>

            {availableSlots.length > 0 ? (

                availableSlots.map(
                    (slot, index) => (
                        <option
                            key={index}
                            value={slot.value}
                        >
                            {slot.label}
                        </option>
                    )
                )

            ) : (

                <option disabled>
                    No Slots Available
                </option>

            )}

        </select>
    </div>
</div>
                </div>
            </div>

            <div className="confirm-modal-footer">
                <button
                    type="button"
                    className="btn btn-light fw-bold px-4"
                    onClick={handleClose}
                >
                    <i className="bi bi-x-circle me-2"></i>
                    Close
                </button>

                <button
                    type="button"
                    className="btn btn-primary fw-bold px-4"
                    onClick={handleConfirm}
                    disabled={!doctorId || !timeSlot}
                >
                    <i className="bi bi-check2-circle me-2"></i>
                    Confirm Appointment
                </button>
            </div>

            <style>
                {`
                .confirm-appointment-modal .ant-modal-content {
                border-radius: 20px;
                overflow: hidden;
                padding: 0;
                }

                .confirm-modal-header {
                padding: 24px;
                background: linear-gradient(135deg, #0f766e, #2563eb);
                color: #fff;
                display: flex;
                align-items: center;
                gap: 16px;
                }

                .confirm-modal-icon {
                width: 54px;
                height: 54px;
                border-radius: 50%;
                background: rgba(255, 255, 255, 0.2);
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 26px;
                }

                .confirm-modal-header h3 {
                margin: 0;
                font-size: 22px;
                font-weight: 900;
                color: #fff;
                }

                .confirm-modal-header p {
                margin: 4px 0 0;
                color: rgba(255, 255, 255, 0.78);
                font-weight: 600;
                }

                .confirm-modal-body {
                padding: 24px;
                background: #f8fafc;
                }

                .input-icon-wrap {
                position: relative;
                }

                .input-icon-wrap > i {
                position: absolute;
                left: 14px;
                top: 50%;
                transform: translateY(-50%);
                color: #2563eb;
                font-size: 18px;
                z-index: 2;
                }

                .input-icon-wrap .form-select {
                padding-left: 44px;
                border-radius: 14px;
                border-color: #e5e7eb;
                font-size: 14px;
                font-weight: 700;
                min-height: 46px;
                }

                .confirm-modal-footer {
                padding: 16px 24px;
                background: #fff;
                border-top: 1px solid #eef2f7;
                display: flex;
                justify-content: flex-end;
                gap: 10px;
                }
            `}
            </style>
        </Modal>
    );
}
